import React, { createContext, useContext } from 'react';

const KioskContext = createContext();

export const KioskProvider = ({ children }) => {
  const isKiosk = (() => {
    // Check URL parameter first (most authoritative)
    const params = new URLSearchParams(window.location.search);
    if (params.get('mode') === 'kiosk') {
      sessionStorage.setItem('kiosk', 'true');
      // Migrate: clear any stale localStorage flag
      localStorage.removeItem('kiosk');
      return true;
    }

    // Fall back to sessionStorage (persists within the same tab session,
    // e.g. when Monobank redirects back without the ?mode=kiosk param)
    if (sessionStorage.getItem('kiosk') === 'true') return true;

    return false;
  })();

  return (
    <KioskContext.Provider value={{ isKiosk }}>
      {children}
    </KioskContext.Provider>
  );
};

export const useKiosk = () => {
  const context = useContext(KioskContext);
  if (!context) {
    throw new Error('useKiosk must be used within a KioskProvider');
  }
  return context;
};
